import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import React from "react";

export default function SelectGroupDialog({
  visible,                // controlled visibility
  onHide,                 // callback when dialog closes
  groupNames = [],        // list of groups
  functionToCall,
  title
}) {
  const [selectedGroup, setSelectedGroup] = React.useState(null);

  const handleUpdate = () => {
    if (selectedGroup) {
      functionToCall(selectedGroup);
      setSelectedGroup(null);  // reset selection
      onHide();                 // close the modal
    }
  };

  return (
    <Dialog
      header={title}
      visible={visible}
      onHide={onHide}
      style={{ width: "25rem" }}
    >
      <Dropdown
        value={selectedGroup}
        onChange={(e) => setSelectedGroup(e.value)}
        options={groupNames.sort((a, b) => a.localeCompare(b))}
        placeholder="Select a group"
        filter
        className="w-full"
      />
      <br />
      <Button
        style={{marginTop:"25px"}}
        label="Update"
        onClick={handleUpdate}
        disabled={!selectedGroup}
        className="mt-3"
      />
    </Dialog>
  );
}
